import { FC } from 'react';
import { Link } from 'react-router-dom';

import { heartCrack } from '../../assets';

interface NoContentFoundProps {
  contentTitle?: string;
}

const NoContentFound: FC<NoContentFoundProps> = ({
  contentTitle = 'sales',
}) => {
  return (
    <section className="flex flex-col items-center sm:items-start py-10 sm:py-20 mt-6 w-full">
      <div className="flex flex-col text-slate-900 text-center sm:text-left">
        <img
          loading="lazy"
          src={heartCrack}
          className="w-16 sm:w-20 mx-auto sm:mx-0"
          alt="heartbroken"
        />
        <div className="flex flex-col mt-2">
          <h2 className="text-2xl sm:text-3xl font-semibold">{`No ${contentTitle} found`}</h2>
          <p className="mt-2 text-lg sm:text-xl">{`Looks like you don't have ${contentTitle} yet`}</p>
        </div>
      </div>
      <Link to="/sales/create-fund" className="w-full sm:w-auto mt-4">
        <button className="btn-primary w-full sm:w-auto">Start a sale</button>
      </Link>
    </section>
  );
};

export default NoContentFound;
